import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  Optional,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import {
  RouterStaticLinkDirectiveModule,
  setThemeColorVars,
} from '@icilalune/utils';
import { isScullyRunning } from '@scullyio/ng-lib';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SvgIconComponentModule } from '@nx-icilalune/icilalune/media';

@Component({
  selector: 'i2l-rgpd-prompt',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    RouterStaticLinkDirectiveModule,
    SvgIconComponentModule,
  ],
  template: `
    <ng-container *ngIf="!scullyRunning">
      <ng-container *transloco="let t">
        <div class="b-content">
          <div class="header">
            <ng-container *ngIf="title">
              <h3 [innerHTML]="t(title)"></h3>
            </ng-container>
            <ng-container *ngIf="message">
              <p [innerHTML]="t(message)"></p>
            </ng-container>
          </div>
          <a class="lune-btn main" href="javascript:openAxeptioCookies()">
            <span [innerHTML]="t('rgpd.accept')"></span>
          </a>
          <a class="lune-btn secondary" [routerStaticLink]="t('rgpd.link.url')">
            <span [innerHTML]="t('rgpd.link.title')"></span>
          </a>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isModal">
      <button (click)="onClose()" class="close-btn">
        <i2l-svg-icon icon="close"></i2l-svg-icon>
      </button>
    </ng-container>
  `,
  styleUrls: ['./rgpd-prompt.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RgpdPromptComponent {
  scullyRunning = isScullyRunning();

  @Input() set backgroundUrl(url: string | undefined) {
    if (url) {
      this.el.nativeElement.style.setProperty(
        '--background-url',
        `url(${url})`
      );
    }
  }

  @Input() privacyPolicyUrl: string | undefined;

  @Input()
  title: string | undefined;

  @Input()
  message!: string | undefined;

  //TODO data is any cause to circular dependency problem. Create a dedicated lib for RGPD instead.

  constructor(
    private el: ElementRef<HTMLElement>,
    @Optional() private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.title = this.data.title;
      this.message = this.data.message;
      if (data.color) {
        setThemeColorVars(data.color, this.el.nativeElement);
      }
    }
  }

  get isModal(): boolean {
    return !!this.dialogRef;
  }

  onClose() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
